<template>
  <b-container class="p-0">
    <b-row>
      <b-col md="4">
        <b-link data-test-path="number-of-attachments" style="font-size: 17px" @click="openAttachments">
          {{fieldConfig ? fieldConfig.fieldLabel : ''}} <S v-if="unsavedAttachments > 0">[{{ numberOfAttachments }}]</S>
          <span v-else>[{{ numberOfAttachments }}]</span>
          <span v-if="numberOfAttachments <= 3 && numberOfAttachments !== 0">:</span>
          <span v-if="unsavedAttachments > 0">[{{ unsavedAttachments }}]</span>
        </b-link>
      </b-col>
      <b-col md="8" v-if="unsavedAttachments > 0"  class="text-danger" style="font-size: 17px">
        <label>Save changes to keep attachments list.</label>
      </b-col>
    </b-row>
    <b-row v-if="validatedField && !validatedField.isValid">
      <b-col>
        <small style="margin-top: 2px; margin-left: 10px;"
               class="form-text text-danger font-weight-bold">{{validatedField.errorMessage || '&nbsp;' }}
        </small>
      </b-col>
    </b-row>
    <div v-if="numberOfAttachments <= 3 && attachmentLists">
      <b-row v-for="attachment in attachmentLists" :key="attachment.token">
        <b-col style="padding-left: 35px">
          <b-link v-if=
                      "
                      attachment.data.mime === 'image/jpeg' ||
                      attachment.data.mime === 'image/png' ||
                      attachment.data.mime === 'image/gif' ||
                      attachment.data.mime === 'image/webp' ||
                      attachment.data.mime === 'image/tiff' ||
                      attachment.data.mime === 'image/svg+xml' ||
                      attachment.data.mime === 'image/vnd.microsoft.icon' ||
                      attachment.data.mime === 'image/bmp'
                      ">
            <font-awesome-icon icon="search" @click="showImageDialog(attachment)" style="color: #007bff"/>
          </b-link>
          <a :href="attachment.downloadUrl">{{ attachment.data.name }}</a>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>


import FormValidatedField from "@/components/forms/FormValidatedField";
import AttachmentsFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/AttachmentsFormFieldConfig";

export default {
  name: "AttachmentsList",

  mounted() {
  },

  methods: {
    openAttachments() {
      this.$emit('list-of-attachments');
    },
    async showImageDialog(attachment) {
      await DialogManager.image(attachment);
    }
  },

  props: {
    validatedField: { type: FormValidatedField, required:false},
    fieldConfig: {type: AttachmentsFormFieldConfig, required: true},
    listOfAttachments: Function,
    readOnly: {type: Boolean, default: false},
    unsavedAttachments: {type: Number, default: 0},
    numberOfAttachments: {type: Number, default: 0},
    attachmentLists: {
      type: Array, default: function () {
        return []
      }
    }
  },

  data: () => ({})
}
</script>
